export const repairRequestTypes = [{ label: 'Sửa chữa', value: 'provide' }];


export const approverType = {
    approver: 1,
    itlead: 2,
    ithead: 3,
    assignee: 4,
}